import firebase from 'firebase'
import firestore from 'firebase/firestore'

var config = {
    apiKey: "AIzaSyA1s9W8PQBA99Lavm48ZLwyRWasaH8-QkI",
    authDomain: "datachester.firebaseapp.com",
    databaseURL: "https://datachester.firebaseio.com",
    projectId: "datachester",
    storageBucket: "datachester.appspot.com",
    messagingSenderId: "32557551040"
};

const firebaseApp = firebase.initializeApp(config);
firebaseApp.firestore().settings({ timestampsInSnapshots: true });

export default firebaseApp.firestore()


// WEBPACK FOOTER //
// ./src/firebase/init.js